<div class="d-flex flex-column justify-content-center align-items-center p-0 m-0 mt-5 dirw-bg-loading"
  [style]="'--backgroundImg:url('+ profilePath +')'">
  @if (mode == _enumPageMode.DISPLAY) {
    <div class="col-12 col-sm-10 col-md-6 col-lg-4 text-center px-4">
        <div class="m-0 p-0 text-center {{
            result == _enumPageResult.ERROR ? 'text-danger' :
            result == _enumPageResult.SUCCESS ? 'text-success' : 'text-secondary' }}" [innerHTML]="header"></div>
        <div class="m-0 p-0 text-center {{
            result == _enumPageResult.ERROR ? 'text-danger' :
            result == _enumPageResult.SUCCESS ? 'text-success' : 'text-secondary' }}" [innerHTML]="content"></div>
      @if (useButton) {
        <div class="mt-5 dirw-button-placement">
            <button class="px-3 rounded-pill btn {{
                result == _enumPageResult.ERROR ? 'btn-outline-danger' :
                result == _enumPageResult.SUCCESS ? 'btn-outline-success' : 'btn-outline-secondary' }}"
            (click)="buttonOnClick()" type="button">
            {{ buttonCaption }}
          </button>
        </div>
      }
    </div>
  }
  @else {
  <div class="text-center px-4">
        <div class="spinner-border {{
            result == _enumPageResult.ERROR ? 'text-danger' :
            result == _enumPageResult.SUCCESS ? 'text-success' : 'text-secondary' }}"
      style="width: 3rem; height: 3rem;" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
        <div class="mt-3 text-center {{
            result == _enumPageResult.ERROR ? 'text-danger' :
            result == _enumPageResult.SUCCESS ? 'text-success' : 'text-secondary' }}" [innerHTML]="content"></div>
  </div>
}
</div>